import { DateTime } from 'luxon';

function formatDateDanish(timestamp) {
  if (!timestamp) return '';
  return DateTime.fromISO(timestamp, { setZone: true })
    .toLocal()
    .setLocale('da')
    .toFormat('dd. MMM yyyy');
}

export default formatDateDanish;
